<template>
	<section>
		<header-page
			name="companies-new"
			:title="$route.meta.title"
		/>
		<company-form
			:code-company="codeCompany"
			:company-id="idCompany"
			:code-project="codeProject" />
	</section>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import companyForm from '@/components/companies/company-form';

	export default {
		name: 'page-new-company',
		components: {
			actionSidebar,
			companyForm,
		},
		props: {
			codeProject: {
				type: String,
			},
			codeCompany: {
				type: String,
			},
			idCompany: {
				type: [Number, String],
			},
			nameCompany: {
				type: String,
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/pages/companies/page-company-new.vue